// Icon per menu entry, keyed by the classic menu's sub-menu `type` or top-level `name`.
export const ICONS: Record<string, string> = {
  'basic-info': 'fa-user',
  'change-password': 'fa-lock',
  'my-address': 'fa-map-marker',
  live_events: 'fa-play-circle',
  upcoming_events: 'fa-calendar',
  past_events: 'fa-history',
  'payment-methods': 'fa-credit-card',
  'subscribed-channel': 'fa-television',
  'my-purchases': 'fa-shopping-cart',
  'order-history': 'fa-list-alt',
  'donation-tip': 'fa-heart-o',
  'My Wishlist': 'fa-heart',
  'My Library': 'fa-bookmark',
  'Crypto Instructions': 'fa-info-circle',
};
